"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultIntlAdapter = void 0;
const common_1 = require("./interfaces/common");
/**
 * Used when i18n capability is disabled in ILC.
 * @internal
 */
exports.defaultIntlAdapter = {
    config: {
        default: { locale: 'en-US', currency: 'USD' },
        supported: { locale: ['en-US'], currency: ['USD'] },
        routingStrategy: common_1.RoutingStrategy.PrefixExceptDefault,
    },
    get() {
        return this.config.default;
    },
};
/* istanbul ignore next */
const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
/* istanbul ignore if */
if (isBrowser) {
    exports.defaultIntlAdapter.set = () => { };
}
exports.default = exports.defaultIntlAdapter;
